import type { LookalikeRatio } from "@common/interfaces/KYDMarketing";

export type PageLookalikeAudienceFormValues = {
  pageType?: "facebook" | "instagram";
  pageId: string;
  pageName: string;
  name: string;
  audienceMode?: "engagers" | "lookalike";
  createLookalike: boolean;
  lookalike: {
    name: string;
    ratio: LookalikeRatio;
  };
  type: "page_lookalike";
};

export type StepConfig = {
  id: number;
  title: string;
  subtitle?: string;
  component: React.ComponentType<StepProps>;
  nextButtonText: string;
  canProceed: (form: any) => boolean;
};

export type StepProps = {
  pages: Array<{
    id: string;
    name: string;
  }>;
  instagramAccounts: Array<{
    id: string;
    username: string;
  }>;
  lookalikeOptions: Array<{
    title: string;
    description: string;
    value: LookalikeRatio;
    icon: React.ReactElement;
    iconBgColor: string;
    isRecommended: boolean;
  }>;
};

export const buildLookalikeName = (name: string, ratio: LookalikeRatio): string =>
  `${name} - Page Audience (Lookalike ${ratio})`;
